<template>
  <UDashboardGroup storage="local" unit="rem" >
    <UDashboardSidebar 
      v-if="isLoggedIn"
      id="default"
      v-model:open="open"
      v-model:collapsed="isSidebarCollapsed"
      resizable
      collapsible
      :min-size="14"
      :default-size="14"
      :max-size="14"
      :collapsed-size="4.5"
      class="bg-elevated/25"
      :ui="{
        header: isSidebarCollapsed ? 'h-auto py-3' : 'h-(--ui-header-height)',
        footer: 'hidden lg:flex lg:flex-col lg:border-t lg:border-default gap-1 px-3 py-2'
      }"
    >
      <template #header="{ collapsed }">
        <div class="flex items-center" :class="collapsed ? 'flex-col gap-2 justify-center border-b border-(--ui-border) pb-3 w-full' : 'justify-between'">
          <RouterLink to="/" class="flex-1 min-w-0" :class="collapsed ? 'flex justify-center' : ''">
            <svg v-if="colorMode.value === 'light' && !collapsed" class="hidden lg:block" width="300" height="38" viewBox="0 0 300 38" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 90%; margin: 0 auto;">
              <g clip-path="url(#clip0_36_49)">
                <path d="M191.51 37.248L174.18 0.0208435H164.752L175.13 28.5684C175.503 29.416 175.876 30.3654 176.249 31.2469C176.792 32.5691 177.3 33.8236 177.674 34.7051C178.047 35.5866 177.877 35.2137 177.945 35.4171C178.759 37.2819 180.828 37.2819 180.828 37.248H191.544L187.135 28.0938" fill="url(#paint0_linear_36_49)"/>
                <path d="M147.389 37.248L164.752 0.0208435H174.18L163.803 28.5684C163.43 29.416 163.057 30.3654 162.684 31.2469C162.141 32.5691 161.632 33.8236 161.259 34.7051C161.158 34.9764 161.056 35.2137 160.988 35.4171C160.174 37.2819 158.105 37.2819 158.105 37.248H147.389L151.797 28.0938Z" fill="#C8017D"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M300 37.0445H286.57L276.735 13.8539L266.9 37.0445H253.708L271.275 0.122559H282.433L300 37.0445ZM0 0.529425C16.4142 -0.114761 41.5103 -0.589425 41.3068 18.7022C41.5442 38.0956 16.6516 38.0617 0 37.3158V0.529425ZM16.9568 28.2633C32.8962 29.0092 32.8962 8.83602 16.9568 9.54802H12.0393V28.2633H16.9568ZM92.4486 0.529419H104.556V37.3158H92.4486V0.529419ZM45.8173 0.531477L45.7834 0.529422H45.8173V0.531477ZM45.8173 0.531477C47.9081 0.656835 50.7803 0.589418 53.999 0.513869C63.6062 0.28837 76.2998 -0.00957406 80.511 4.53015C87.565 10.3278 84.411 22.1605 75.4239 24.4999L85.8015 37.3158H71.8969L63.1472 26.1612H57.8567V37.3158H45.8173V0.531477ZM65.7246 9.37849C74.2709 8.76821 74.5082 18.6005 65.7924 18.1937H65.7585H57.8227V9.37849H65.7246ZM196.563 0.665027H208.535V28.3311H229.46V37.2141H196.563V0.665027ZM248.282 0.325989H235.971V37.2141H248.282V0.325989ZM121.919 0.258167H108.422L126.057 37.3158H137.248L154.884 0.258167H141.657L131.788 23.5505L121.919 0.258167Z" fill="#18305B"/>
              </g>
              <defs>
                <linearGradient id="paint0_linear_36_49" x1="164.074" y1="0.665029" x2="190.348" y2="38.2379" gradientUnits="userSpaceOnUse">
                  <stop offset="0.2" stop-color="#186BA1"/>
                  <stop offset="0.3" stop-color="#078FCB"/>
                  <stop offset="0.4" stop-color="#00A0DF"/>
                  <stop offset="1" stop-color="#00A0DF"/>
                </linearGradient>
                <clipPath id="clip0_36_49">
                  <rect width="300" height="37.574" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            
            <svg v-if="colorMode.value === 'dark' && !collapsed" class="hidden lg:block" width="300" height="38" viewBox="0 0 300 38" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 90%; margin: 0 auto;">
              <g clip-path="url(#clip0_36_76)">
                <path d="M191.51 37.248L174.18 0.0208435H164.752L175.13 28.5684C175.503 29.416 175.876 30.3654 176.249 31.2469C176.792 32.5691 177.3 33.8236 177.674 34.7051C178.047 35.5866 177.877 35.2137 177.945 35.4171C178.759 37.2819 180.828 37.2819 180.828 37.248H191.544L187.135 28.0938" fill="url(#paint0_linear_36_76)"/>
                <path d="M147.389 37.248L164.752 0.0208435H174.18L163.803 28.5684C163.43 29.416 163.057 30.3654 162.684 31.2469C162.141 32.5691 161.632 33.8236 161.259 34.7051C161.158 34.9764 161.056 35.2137 160.988 35.4171C160.174 37.2819 158.105 37.2819 158.105 37.248H147.389L151.797 28.0938Z" fill="#C8017D"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M300 37.0445H286.57L276.735 13.8539L266.9 37.0445H253.708L271.275 0.122559H282.433L300 37.0445ZM0 0.529425C16.4142 -0.114761 41.5103 -0.589425 41.3068 18.7022C41.5442 38.0956 16.6516 38.0617 0 37.3158V0.529425ZM16.9568 28.2633C32.8962 29.0092 32.8962 8.83602 16.9568 9.54802H12.0393V28.2633H16.9568ZM92.4486 0.529419H104.556V37.3158H92.4486V0.529419ZM45.8173 0.531477L45.7834 0.529422H45.8173V0.531477ZM45.8173 0.531477C47.9081 0.656835 50.7803 0.589418 53.999 0.513869C63.6062 0.28837 76.2998 -0.00957406 80.511 4.53015C87.565 10.3278 84.411 22.1605 75.4239 24.4999L85.8015 37.3158H71.8969L63.1472 26.1612H57.8567V37.3158H45.8173V0.531477ZM65.7246 9.37849C74.2709 8.76821 74.5082 18.6005 65.7924 18.1937H65.7585H57.8227V9.37849H65.7246ZM196.563 0.665027H208.535V28.3311H229.46V37.2141H196.563V0.665027ZM248.282 0.325989H235.971V37.2141H248.282V0.325989ZM121.919 0.258167H108.422L126.057 37.3158H137.248L154.884 0.258167H141.657L131.788 23.5505L121.919 0.258167Z" fill="white"/>
              </g>
              <defs>
                <linearGradient id="paint0_linear_36_76" x1="164.074" y1="0.665029" x2="190.348" y2="38.2379" gradientUnits="userSpaceOnUse">
                  <stop offset="0.2" stop-color="#186BA1"/>
                  <stop offset="0.3" stop-color="#078FCB"/>
                  <stop offset="0.4" stop-color="#00A0DF"/>
                  <stop offset="1" stop-color="#00A0DF"/>
                </linearGradient>
                <clipPath id="clip0_36_76">
                  <rect width="300" height="37.574" fill="white"/>
                </clipPath>
              </defs>
            </svg>

            <svg v-if="collapsed" width="48" height="40" viewBox="0 0 80 68" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 80%; margin: 0 auto;">
              <g clip-path="url(#clip0_38_84)">
                <path d="M79.9607 68L48.5082 0H31.4304L50.2282 52.1457C50.904 53.694 51.5797 55.428 52.2554 57.0382C53.2383 59.4535 54.1598 61.745 54.8355 63.3552C55.5113 64.9654 55.2041 64.2841 55.327 64.6557C56.8013 68.0619 60.5486 68.0619 60.5486 68H79.9607L71.9747 51.2787Z" fill="url(#paint0_linear_38_84)"/>
                <path d="M0.0393066 68L31.4919 0H48.5696L29.7718 52.1457C29.0961 53.694 28.4203 55.428 27.7446 57.0382C26.7617 59.4535 25.8402 61.745 25.1645 63.3552C24.9802 63.8506 24.7959 64.2841 24.673 64.6557C23.1987 68.0619 19.4514 68.0619 19.4514 68H0.0393066L8.0253 51.2787Z" fill="#C8017D"/>
              </g>
              <defs>
               <linearGradient id="paint0_linear_38_84" x1="30.2632" y1="1.17668" x2="78.3918" y2="69.4295" gradientUnits="userSpaceOnUse">
                  <stop offset="0.2" stop-color="#186BA1"/>
                  <stop offset="0.3" stop-color="#078FCB"/>
                  <stop offset="0.4" stop-color="#00A0DF"/>
                  <stop offset="1" stop-color="#00A0DF"/>
                </linearGradient>
                <clipPath id="clip0_38_84">
                  <rect width="80" height="68" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </RouterLink>
          <UButton
            :icon="collapsed ? 'i-lucide-panel-left-open' : 'i-lucide-panel-left-close'"
            variant="ghost"
            color="neutral"
            size="sm"
            class="hidden lg:inline-flex flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity"
            @click="isSidebarCollapsed = !isSidebarCollapsed"
          />
        </div>
      </template>
      
      <template #default="{ collapsed }">
        <UNavigationMenu
          :collapsed="collapsed"
          :items="filteredLinks"
          orientation="vertical"
          tooltip
          :ui="{
            link: `group relative flex items-center gap-3 px-3 py-2.5 rounded-md text-base border-x-2 border-transparent text-slate-700 dark:text-slate-200 focus:outline-none focus-visible:outline-none dark:focus-visible:outline-none focus-visible:before:ring-inset focus-visible:before:ring-2 focus-visible:before:ring-primary-500 dark:focus-visible:before:ring-primary-400 before:absolute before:inset-px before:rounded-md disabled:cursor-not-allowed disabled:opacity-75 hover:bg-elevated/40 aria-[current=page]:bg-[#C8017D]/10 dark:aria-[current=page]:bg-[#C8017D]/20 aria-[current=page]:border-l-[#C8017D] aria-[current=page]:font-semibold aria-[current=page]:text-[#C8017D] ${collapsed ? 'justify-center' : ''}`
          }"
        />
      </template>
      
      <template #footer="{ collapsed }">
        <div class="px-1 pb-1" :class="collapsed ? 'flex justify-center' : ''">
          <LanguageSwitcher :collapsed="collapsed" />
        </div>
        <div class="border-t border-(--ui-border) pt-1.5">
          <UserMenu :collapsed="collapsed" />
        </div>
      </template>
    </UDashboardSidebar>
    
    <div class="flex flex-col flex-1 min-w-0 min-h-0 overflow-hidden lg:overflow-visible">
      <div v-if="isLoggedIn" class="lg:hidden sticky top-0 z-40 flex items-center gap-2 px-3 py-2 border-b border-default bg-default/95 backdrop-blur-sm">
        <div class="flex items-center gap-2 min-w-0">
          <UButton
            :icon="open ? 'i-lucide-x' : 'i-lucide-menu'"
            variant="ghost"
            color="neutral"
            size="md"
            :aria-expanded="open"
            aria-controls="default"
            @click="open = !open"
          />
          <RouterLink to="/" class="flex items-center min-w-0">
            <svg v-if="colorMode.value === 'light'" width="110" height="20" viewBox="0 0 300 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_mobile_light)">
                <path d="M191.51 37.248L174.18 0.0208435H164.752L175.13 28.5684C175.503 29.416 175.876 30.3654 176.249 31.2469C176.792 32.5691 177.3 33.8236 177.674 34.7051C178.047 35.5866 177.877 35.2137 177.945 35.4171C178.759 37.2819 180.828 37.2819 180.828 37.248H191.544L187.135 28.0938" fill="url(#paint0_mobile_light)"/>
                <path d="M147.389 37.248L164.752 0.0208435H174.18L163.803 28.5684C163.43 29.416 163.057 30.3654 162.684 31.2469C162.141 32.5691 161.632 33.8236 161.259 34.7051C161.158 34.9764 161.056 35.2137 160.988 35.4171C160.174 37.2819 158.105 37.2819 158.105 37.248H147.389L151.797 28.0938Z" fill="#C8017D"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M300 37.0445H286.57L276.735 13.8539L266.9 37.0445H253.708L271.275 0.122559H282.433L300 37.0445ZM0 0.529425C16.4142 -0.114761 41.5103 -0.589425 41.3068 18.7022C41.5442 38.0956 16.6516 38.0617 0 37.3158V0.529425ZM16.9568 28.2633C32.8962 29.0092 32.8962 8.83602 16.9568 9.54802H12.0393V28.2633H16.9568ZM92.4486 0.529419H104.556V37.3158H92.4486V0.529419ZM45.8173 0.531477L45.7834 0.529422H45.8173V0.531477ZM45.8173 0.531477C47.9081 0.656835 50.7803 0.589418 53.999 0.513869C63.6062 0.28837 76.2998 -0.00957406 80.511 4.53015C87.565 10.3278 84.411 22.1605 75.4239 24.4999L85.8015 37.3158H71.8969L63.1472 26.1612H57.8567V37.3158H45.8173V0.531477ZM65.7246 9.37849C74.2709 8.76821 74.5082 18.6005 65.7924 18.1937H65.7585H57.8227V9.37849H65.7246ZM196.563 0.665027H208.535V28.3311H229.46V37.2141H196.563V0.665027ZM248.282 0.325989H235.971V37.2141H248.282V0.325989ZM121.919 0.258167H108.422L126.057 37.3158H137.248L154.884 0.258167H141.657L131.788 23.5505L121.919 0.258167Z" fill="#18305B"/>
              </g>
              <defs>
                <linearGradient id="paint0_mobile_light" x1="164.074" y1="0.665029" x2="190.348" y2="38.2379" gradientUnits="userSpaceOnUse">
                  <stop offset="0.2" stop-color="#186BA1"/>
                  <stop offset="0.3" stop-color="#078FCB"/>
                  <stop offset="0.4" stop-color="#00A0DF"/>
                  <stop offset="1" stop-color="#00A0DF"/>
                </linearGradient>
                <clipPath id="clip0_mobile_light"><rect width="300" height="37.574" fill="white"/></clipPath>
              </defs>
            </svg>
            <svg v-if="colorMode.value === 'dark'" width="110" height="20" viewBox="0 0 300 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_mobile_dark)">
                <path d="M191.51 37.248L174.18 0.0208435H164.752L175.13 28.5684C175.503 29.416 175.876 30.3654 176.249 31.2469C176.792 32.5691 177.3 33.8236 177.674 34.7051C178.047 35.5866 177.877 35.2137 177.945 35.4171C178.759 37.2819 180.828 37.2819 180.828 37.248H191.544L187.135 28.0938" fill="url(#paint0_mobile_dark)"/>
                <path d="M147.389 37.248L164.752 0.0208435H174.18L163.803 28.5684C163.43 29.416 163.057 30.3654 162.684 31.2469C162.141 32.5691 161.632 33.8236 161.259 34.7051C161.158 34.9764 161.056 35.2137 160.988 35.4171C160.174 37.2819 158.105 37.2819 158.105 37.248H147.389L151.797 28.0938Z" fill="#C8017D"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M300 37.0445H286.57L276.735 13.8539L266.9 37.0445H253.708L271.275 0.122559H282.433L300 37.0445ZM0 0.529425C16.4142 -0.114761 41.5103 -0.589425 41.3068 18.7022C41.5442 38.0956 16.6516 38.0617 0 37.3158V0.529425ZM16.9568 28.2633C32.8962 29.0092 32.8962 8.83602 16.9568 9.54802H12.0393V28.2633H16.9568ZM92.4486 0.529419H104.556V37.3158H92.4486V0.529419ZM45.8173 0.531477L45.7834 0.529422H45.8173V0.531477ZM45.8173 0.531477C47.9081 0.656835 50.7803 0.589418 53.999 0.513869C63.6062 0.28837 76.2998 -0.00957406 80.511 4.53015C87.565 10.3278 84.411 22.1605 75.4239 24.4999L85.8015 37.3158H71.8969L63.1472 26.1612H57.8567V37.3158H45.8173V0.531477ZM65.7246 9.37849C74.2709 8.76821 74.5082 18.6005 65.7924 18.1937H65.7585H57.8227V9.37849H65.7246ZM196.563 0.665027H208.535V28.3311H229.46V37.2141H196.563V0.665027ZM248.282 0.325989H235.971V37.2141H248.282V0.325989ZM121.919 0.258167H108.422L126.057 37.3158H137.248L154.884 0.258167H141.657L131.788 23.5505L121.919 0.258167Z" fill="white"/>
              </g>
              <defs>
                <linearGradient id="paint0_mobile_dark" x1="164.074" y1="0.665029" x2="190.348" y2="38.2379" gradientUnits="userSpaceOnUse">
                  <stop offset="0.2" stop-color="#186BA1"/>
                  <stop offset="0.3" stop-color="#078FCB"/>
                  <stop offset="0.4" stop-color="#00A0DF"/>
                  <stop offset="1" stop-color="#00A0DF"/>
                </linearGradient>
                <clipPath id="clip0_mobile_dark"><rect width="300" height="37.574" fill="white"/></clipPath>
              </defs>
            </svg>
          </RouterLink>
        </div>
        
        <div class="flex items-center gap-1.5 ml-auto">
          <LanguageSwitcher :collapsed="true" />
          <UserMenu :collapsed="true" disableTooltip />
        </div>
      </div>
      
      <slot />
    </div>
  </UDashboardGroup>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useColorMode } from '#imports'
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router'
import { useUser } from '@/store'
import { useViewStore } from '@/store/ViewStore.ts'
import type { Permission } from '@/types/enums/Permission'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

const { t } = useI18n()

const open = ref(false)
const isSidebarCollapsed = ref(false)

const colorMode = useColorMode()
const router = useRouter()
const userStore = useUser();
const viewStore = useViewStore();
const isLoggedIn = computed(() => userStore.isAuthenticated());

if (colorMode.preference === 'system') {
  colorMode.preference = 'light'
}

onMounted(() => {
  viewStore.initializeView()
})

const filteredLinks = computed(() => {
  return links.value.filter(link => {
    const route = router.getRoutes().find(r => r.path === link.to)

    if (!route || !route.meta?.permissions) {
      return true
    }

    const permissions = route.meta.permissions as Permission[]
    return userStore.hasPermission(...permissions)
  })
})

const links = computed(() => [
  {
    label: t('navigation.dashboard'),
    icon: 'i-lucide-list-todo',
    to: '/',
    onSelect: () => { open.value = false }
  },
  {
    label: t('navigation.workflows'),
    to: '/workflows',
    icon: 'i-mdi-car-clock',
    onSelect: () => { open.value = false }
  },
  {
    label: t('navigation.clients'),
    to: '/clients',
    icon: 'i-lucide-users',
    onSelect: () => { open.value = false }
  },
  {
    label: t('navigation.users'),
    to: '/users',
    icon: 'i-lucide-user-plus',
    onSelect: () => { open.value = false }
  },
  {
    label: t('navigation.sapImport'),
    to: '/sap-import',
    icon: 'i-lucide-file-input',
    onSelect: () => { open.value = false }
  },
  {
    label: t('navigation.nolsImport'),
    to: '/nols-import',
    icon: 'i-lucide-file-input',
    onSelect: () => { open.value = false }
  },
  {
    label: t('navigation.deadLetters'),
    to: '/dead-letters',
    icon: 'i-lucide-mail-warning',
    onSelect: () => { open.value = false }
  }
])
</script>